import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'eventFilter',
    'alertFilter',
    'eventReplacementText',
    'checkbox',
    'alertParams',
    'alarmTypesFilter',
    'closureReasonsFilter',
  ];

  toggleFilters(event) {
    if (['events', 'alerts'].includes(event.target.value)) {
      this.eventFilterTarget.classList.remove('d-none');
      this.eventReplacementTextTarget.classList.add('d-none');
      this.checkboxTargets.forEach((el) => (el.disabled = false));
    } else {
      this.eventFilterTarget.classList.add('d-none');
      this.eventReplacementTextTarget.classList.remove('d-none');
      this.checkboxTargets.forEach((el) => (el.disabled = true));
    }

    if (event.target.value == 'alerts') {
      this.alertFilterTarget.classList.remove('d-none');
      this.alertParamsTargets.forEach((el) => (el.disabled = false));
    } else {
      this.alertFilterTarget.classList.add('d-none');
      this.alertParamsTargets.forEach((el) => (el.disabled = true));
    }
  }

  toggleAlarmTypes(event) {
    if (['alerts', 'alerts_events'].includes(event.target.value)) {
      this.alarmTypesFilterTarget.classList.remove('d-none');
    } else {
      this.alarmTypesFilterTarget.classList.add('d-none');
    }
  }

  toggleClosureReasons(event) {
    if (['events'].includes(event.target.value)) {
      this.closureReasonsFilterTarget.classList.add('d-none');
    } else {
      this.closureReasonsFilterTarget.classList.remove('d-none');
    }
  }
}
